export function apiGet (vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params }

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL + url

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiGetSupport (vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params }

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL_SUPPORT + url

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiGetSupportV2 (vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params }

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL_SUPPORT_V2 + url

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiGetSupportV3 (vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params }

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL_SUPPORT_V3 + url

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiGetSupportV4(vm, url, params, onSuccess, onError, onFinish) {
  var obj = { params: params }

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL_SUPPORT_V4 + url

  vm.axios.get(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiPost (vm, url, params, onSuccess, onError, onFinish) {
  var obj = params

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL + url

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiPostSupport (vm, url, params, onSuccess, onError, onFinish) {
  var obj = params

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL_SUPPORT + url

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function apiPostPay (vm, url, params, onSuccess, onError, onFinish) {
  var obj = params

  if (url.substring(0, 4) !== 'http') url = process.env.API_URL_PAYOUTS + url

  vm.axios.post(url, obj).then(function (response) {
    var data = response.data
    onSuccess(data)
    if (onFinish) onFinish()
  }).catch(function (error) {
    onError(error)
    if (onFinish) onFinish()
  })
}

export function debounce (fn, delay) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}



// WEBPACK FOOTER //
// ./src/util/general.js